<template>
  <section class="mt-14 min-h-screen bg-subtleGray px-3 md:px-6 2xl:px-0 p-3">
    <div class="py-20 pt-16 w-full">
      <h1
        class="
          block
          mb-5
          w-full
          text-center text-gray-800
          font-bold
          text-3xl
          md:text-5xl
        "
      >
        Contributor Guidelines
      </h1>

      <h3
        class="
          block
          mb-10
          w-full
          text-center text-gray-600 text-sm
          md:text-base
        "
      >
        Please make sure you carefully follow the information below before
        uploading.
      </h3>

      <div
        class="
          w-full
          flex flex-col
          md:flex-row
          md:items-start
          items-center
          justify-center
          gap-10
          max-w-3xl
          2xl:max-w-6xl
          mx-auto
        "
      >
        <button
          @click="handleChange('general', 'quality-and-technical')"
          class="
            w-40
            h-40
            border border-gray-800
            rounded-md
            flex flex-col
            items-center
            flex-shrink-0
            focus:outline-none
            justify-center
          "
        >
          <svg
            :class="mainCat === 'general' ? 'text-gray-800' : 'text-gray-600'"
            class="w-10 h-10"
            viewBox="0 0 106 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M94.8597 12.6191H49.2226L39.3359 0.864979C39.1079 0.594165 38.8235 0.376435 38.5026 0.227025C38.1817 0.0776149 37.832 0.000132784 37.478 8.20699e-08H2.42665C2.10795 -8.28111e-05 1.79236 0.0626286 1.49791 0.18455C1.20346 0.306471 0.935916 0.485213 0.710564 0.710564C0.485213 0.935916 0.30647 1.20346 0.184549 1.49791C0.062628 1.79236 -8.28111e-05 2.10795 8.20706e-08 2.42665V78.2357C0.00345527 81.1893 1.17827 84.0208 3.26674 86.1093C5.3552 88.1978 8.18678 89.3726 11.1403 89.3761H94.8597C97.8132 89.3726 100.645 88.1978 102.733 86.1093C104.822 84.0208 105.997 81.1893 106 78.2357V23.7582C105.997 20.8048 104.822 17.9733 102.733 15.8851C100.645 13.7968 97.8131 12.6222 94.8597 12.6191ZM4.8533 4.8533H36.3476L42.8811 12.6191H4.8533V4.8533ZM101.147 78.2357C101.145 79.9026 100.482 81.5007 99.3033 82.6794C98.1247 83.858 96.5266 84.521 94.8597 84.5228H11.1403C9.47344 84.521 7.87534 83.858 6.69669 82.6794C5.51803 81.5007 4.85508 79.9026 4.8533 78.2357V17.4725H94.8597C96.5264 17.4742 98.1243 18.1369 99.3029 19.3153C100.482 20.4937 101.145 22.0915 101.147 23.7582V78.2357Z"
              fill="currentColor"
            />
          </svg>
          <span
            :class="
              mainCat === 'general'
                ? 'border-b-2 border-brandPurple text-gray-800'
                : 'text-gray-600'
            "
            class="mt-2 text-sm text-gray-600"
            >General</span
          >
        </button>

        <button
          @click="handleChange('video-templates', 'after-effects')"
          class="
            w-40
            h-40
            border border-gray-800
            rounded-md
            flex flex-col
            items-center
            flex-shrink-0
            focus:outline-none
            justify-center
          "
        >
          <svg
            :class="
              mainCat === 'video-template' ? 'text-gray-800' : 'text-gray-600'
            "
            class="w-10 h-10"
            viewBox="0 0 106 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M97.67 19.48C97.67 16.2974 96.4057 13.2451 94.1553 10.9947C91.9049 8.74426 88.8526 7.47998 85.67 7.47998H14.33C11.1474 7.47998 8.09517 8.74426 5.84474 10.9947C3.5943 13.2451 2.33002 16.2974 2.33002 19.48V80.48C2.33002 83.6626 3.5943 86.7148 5.84474 88.9653C8.09517 91.2157 11.1474 92.48 14.33 92.48H85.67C88.8526 92.48 91.9049 91.2157 94.1553 88.9653C96.4057 86.7148 97.67 83.6626 97.67 80.48V19.48ZM93.67 80.48C93.67 82.6017 92.8272 84.6365 91.3269 86.1368C89.8266 87.6371 87.7917 88.48 85.67 88.48H14.33C12.2083 88.48 10.1735 87.6371 8.67316 86.1368C7.17287 84.6365 6.33002 82.6017 6.33002 80.48V19.48C6.33002 17.3582 7.17287 15.3234 8.67316 13.8231C10.1735 12.3228 12.2083 11.48 14.33 11.48H85.67C87.7917 11.48 89.8266 12.3228 91.3269 13.8231C92.8272 15.3234 93.67 17.3582 93.67 19.48V80.48Z"
              fill="currentColor"
            />
            <path
              d="M79.76 19.4H20.25C18.1283 19.4 16.0934 20.2429 14.5931 21.7432C13.0929 23.2435 12.25 25.2783 12.25 27.4V33.32C12.25 35.4418 13.0929 37.4766 14.5931 38.9769C16.0934 40.4772 18.1283 41.32 20.25 41.32H79.76C81.8817 41.32 83.9166 40.4772 85.4169 38.9769C86.9171 37.4766 87.76 35.4418 87.76 33.32V27.4C87.76 25.2783 86.9171 23.2435 85.4169 21.7432C83.9166 20.2429 81.8817 19.4 79.76 19.4V19.4ZM83.76 33.32C83.76 34.3809 83.3386 35.3983 82.5884 36.1485C81.8383 36.8986 80.8209 37.32 79.76 37.32H20.25C19.1891 37.32 18.1717 36.8986 17.4216 36.1485C16.6714 35.3983 16.25 34.3809 16.25 33.32V27.4C16.25 26.3392 16.6714 25.3217 17.4216 24.5716C18.1717 23.8215 19.1891 23.4 20.25 23.4H79.76C80.8209 23.4 81.8383 23.8215 82.5884 24.5716C83.3386 25.3217 83.76 26.3392 83.76 27.4V33.32Z"
              fill="currentColor"
            />
            <path
              d="M39.23 46.85H20.23C18.1082 46.85 16.0734 47.6928 14.5731 49.1931C13.0728 50.6934 12.23 52.7282 12.23 54.85V75C12.23 77.1217 13.0728 79.1565 14.5731 80.6568C16.0734 82.1571 18.1082 83 20.23 83H39.23C41.3517 83 43.3865 82.1571 44.8868 80.6568C46.3871 79.1565 47.23 77.1217 47.23 75V54.85C47.23 52.7282 46.3871 50.6934 44.8868 49.1931C43.3865 47.6928 41.3517 46.85 39.23 46.85ZM43.23 74.99C43.23 76.0508 42.8086 77.0683 42.0584 77.8184C41.3083 78.5686 40.2908 78.99 39.23 78.99H20.23C19.1691 78.99 18.1517 78.5686 17.4016 77.8184C16.6514 77.0683 16.23 76.0508 16.23 74.99V54.85C16.23 53.7891 16.6514 52.7717 17.4016 52.0215C18.1517 51.2714 19.1691 50.85 20.23 50.85H39.23C40.2908 50.85 41.3083 51.2714 42.0584 52.0215C42.8086 52.7717 43.23 53.7891 43.23 54.85V74.99Z"
              fill="currentColor"
            />
            <path
              d="M79.76 46.85H60.76C58.6383 46.85 56.6034 47.6928 55.1032 49.1931C53.6029 50.6934 52.76 52.7282 52.76 54.85V75C52.76 77.1217 53.6029 79.1565 55.1032 80.6568C56.6034 82.1571 58.6383 83 60.76 83H79.76C81.8817 83 83.9166 82.1571 85.4169 80.6568C86.9172 79.1565 87.76 77.1217 87.76 75V54.85C87.76 52.7282 86.9172 50.6934 85.4169 49.1931C83.9166 47.6928 81.8817 46.85 79.76 46.85ZM83.76 74.99C83.76 76.0508 83.3386 77.0683 82.5884 77.8184C81.8383 78.5686 80.8209 78.99 79.76 78.99H60.76C59.6991 78.99 58.6817 78.5686 57.9316 77.8184C57.1814 77.0683 56.76 76.0508 56.76 74.99V54.85C56.76 53.7891 57.1814 52.7717 57.9316 52.0215C58.6817 51.2714 59.6991 50.85 60.76 50.85H79.76C80.8209 50.85 81.8383 51.2714 82.5884 52.0215C83.3386 52.7717 83.76 53.7891 83.76 54.85V74.99Z"
              fill="currentColor"
            />
          </svg>

          <span
            :class="
              mainCat === 'video-templates'
                ? 'border-b-2 border-brandPurple text-gray-800'
                : 'text-gray-600'
            "
            class="mt-2 text-sm text-gray-600"
            >Video Templates</span
          >
        </button>

        <button
          @click="handleChange('stock-video', 'stock-footage')"
          class="
            w-40
            h-40
            border border-gray-800
            rounded-md
            flex flex-col
            items-center
            flex-shrink-0
            focus:outline-none
            justify-center
          "
        >
          <svg
            :class="
              mainCat === 'stock-video' ? 'text-gray-800' : 'text-gray-600'
            "
            class="w-12 h-12"
            viewBox="0 0 106 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M84 16.5H16C13.8 16.5 12 18.3 12 20.5V79.5C12 81.7 13.8 83.5 16 83.5H84C86.2 83.5 88 81.7 88 79.5V20.5C88 18.3 86.2 16.5 84 16.5ZM15 33H85V67H15V33ZM15 20.5C15 19.958 15.458 19.5 16 19.5H84C84.542 19.5 85 19.958 85 20.5V30H15V20.5ZM85 79.5C85 80.042 84.542 80.5 84 80.5H16C15.458 80.5 15 80.042 15 79.5V70H85V79.5Z"
              fill="currentColor"
            />
            <path
              d="M26.5 77.5C27.8807 77.5 29 76.3807 29 75C29 73.6193 27.8807 72.5 26.5 72.5C25.1193 72.5 24 73.6193 24 75C24 76.3807 25.1193 77.5 26.5 77.5Z"
              fill="currentColor"
            />
            <path
              d="M58.5 77.5C59.8807 77.5 61 76.3807 61 75C61 73.6193 59.8807 72.5 58.5 72.5C57.1193 72.5 56 73.6193 56 75C56 76.3807 57.1193 77.5 58.5 77.5Z"
              fill="currentColor"
            />
            <path
              d="M74.501 77.5C75.8817 77.5 77.001 76.3807 77.001 75C77.001 73.6193 75.8817 72.5 74.501 72.5C73.1203 72.5 72.001 73.6193 72.001 75C72.001 76.3807 73.1203 77.5 74.501 77.5Z"
              fill="currentColor"
            />
            <path
              d="M42.5 77.5C43.8807 77.5 45 76.3807 45 75C45 73.6193 43.8807 72.5 42.5 72.5C41.1193 72.5 40 73.6193 40 75C40 76.3807 41.1193 77.5 42.5 77.5Z"
              fill="currentColor"
            />
            <path
              d="M42.5 27.5C43.8807 27.5 45 26.3807 45 25C45 23.6193 43.8807 22.5 42.5 22.5C41.1193 22.5 40 23.6193 40 25C40 26.3807 41.1193 27.5 42.5 27.5Z"
              fill="currentColor"
            />
            <path
              d="M26.5 27.5C27.8807 27.5 29 26.3807 29 25C29 23.6193 27.8807 22.5 26.5 22.5C25.1193 22.5 24 23.6193 24 25C24 26.3807 25.1193 27.5 26.5 27.5Z"
              fill="currentColor"
            />
            <path
              d="M58.499 27.5C59.8797 27.5 60.999 26.3807 60.999 25C60.999 23.6193 59.8797 22.5 58.499 22.5C57.1183 22.5 55.999 23.6193 55.999 25C55.999 26.3807 57.1183 27.5 58.499 27.5Z"
              fill="currentColor"
            />
            <path
              d="M74.5 27.5C75.8807 27.5 77 26.3807 77 25C77 23.6193 75.8807 22.5 74.5 22.5C73.1193 22.5 72 23.6193 72 25C72 26.3807 73.1193 27.5 74.5 27.5Z"
              fill="currentColor"
            />
            <path
              d="M58.749 48.701L45.749 41.201C45.286 40.931 44.714 40.933 44.25 41.201C43.786 41.469 43.5 41.964 43.5 42.5V57.5C43.5 58.036 43.786 58.531 44.25 58.799C44.481 58.933 44.741 59 45 59C45.259 59 45.518 58.933 45.749 58.799L58.749 51.299C59.214 51.031 59.5 50.536 59.5 50C59.5 49.464 59.214 48.969 58.749 48.701ZM46.5 54.903V45.096L54.999 50L46.5 54.903Z"
              fill="currentColor"
            />
          </svg>

          <span
            :class="
              mainCat === 'stock-video'
                ? 'border-b-2 border-brandPurple text-gray-800'
                : 'text-gray-600'
            "
            class="mt-2 text-sm text-gray-600"
            >Stock Video</span
          >
        </button>

        <button
          @click="handleChange('stock-photos', '')"
          class="
            w-40
            h-40
            border border-gray-800
            rounded-md
            flex flex-col
            items-center
            flex-shrink-0
            focus:outline-none
            justify-center
          "
        >
          <svg class="w-10 h-10" viewBox="0 0 80 83" fill="none">
            <path
              d="M71 7H9C7.9 7 7 7.9 7 9V71C7 72.1 7.9 73 9 73H71C72.1 73 73 72.1 73 71V9C73 7.9 72.1 7 71 7ZM71 71H9V21.67H71V71ZM71 19.67H9V9H71V19.67Z"
              fill="currentColor"
            />
            <path
              d="M14.4004 15.3799H16.9804C17.5304 15.3799 17.9804 14.9299 17.9804 14.3799C17.9804 13.8299 17.5304 13.3799 16.9804 13.3799H14.4004C13.8504 13.3799 13.4004 13.8299 13.4004 14.3799C13.4004 14.9299 13.8404 15.3799 14.4004 15.3799Z"
              fill="currentColor"
            />
            <path
              d="M22.1299 15.3799H24.7099C25.2599 15.3799 25.7099 14.9299 25.7099 14.3799C25.7099 13.8299 25.2599 13.3799 24.7099 13.3799H22.1299C21.5799 13.3799 21.1299 13.8299 21.1299 14.3799C21.1299 14.9299 21.5799 15.3799 22.1299 15.3799Z"
              fill="currentColor"
            />
            <path
              d="M29.8604 15.3799H32.4403C32.9903 15.3799 33.4403 14.9299 33.4403 14.3799C33.4403 13.8299 32.9903 13.3799 32.4403 13.3799H29.8604C29.3104 13.3799 28.8604 13.8299 28.8604 14.3799C28.8604 14.9299 29.3104 15.3799 29.8604 15.3799Z"
              fill="currentColor"
            />
            <path
              d="M38.6904 15.3799H65.6004C66.1504 15.3799 66.6004 14.9299 66.6004 14.3799C66.6004 13.8299 66.1504 13.3799 65.6004 13.3799H38.6904C38.1404 13.3799 37.6904 13.8299 37.6904 14.3799C37.6904 14.9299 38.1304 15.3799 38.6904 15.3799Z"
              fill="currentColor"
            />
            <path
              d="M19.6596 61.0599H60.3396C61.3196 61.0599 62.1096 60.2599 62.1096 59.2899V33.3799C62.1096 32.3999 61.3096 31.6099 60.3396 31.6099H19.6596C18.6796 31.6099 17.8896 32.4099 17.8896 33.3799V59.2899C17.8896 60.2599 18.6796 61.0599 19.6596 61.0599ZM19.8896 33.6099H60.1196V53.5499L49.7197 42.4499C49.5297 42.2499 49.2796 42.1399 49.0096 42.1299C48.7196 42.1299 48.4796 42.2299 48.2896 42.4199L40.0396 50.7099L32.4697 42.4499C32.2797 42.2399 31.9896 42.1299 31.7196 42.1299C31.4296 42.1299 31.1596 42.2599 30.9796 42.4799L19.8896 55.2899V33.6099ZM19.8896 58.3499L31.7496 44.6299L38.6297 52.1299L35.0696 55.7099C34.6796 56.0999 34.6796 56.7299 35.0696 57.1199C35.2696 57.3099 35.5196 57.4099 35.7796 57.4099C36.0396 57.4099 36.2897 57.3099 36.4897 57.1199L48.9897 44.5699L60.1297 56.4699V59.0599H19.8896V58.3499Z"
              fill="currentColor"
            />
            <path
              d="M39.1702 43.0498C41.1102 43.0498 42.6802 41.4798 42.6802 39.5398C42.6802 37.5998 41.1102 36.0298 39.1702 36.0298C37.2302 36.0298 35.6602 37.5998 35.6602 39.5398C35.6602 41.4798 37.2302 43.0498 39.1702 43.0498ZM39.1702 38.0298C40.0002 38.0298 40.6802 38.7098 40.6802 39.5398C40.6802 40.3698 40.0002 41.0498 39.1702 41.0498C38.3402 41.0498 37.6602 40.3698 37.6602 39.5398C37.6602 38.7098 38.3302 38.0298 39.1702 38.0298Z"
              fill="currentColor"
            />
          </svg>

          <span
            :class="
              mainCat === 'stock-photos'
                ? 'border-b-2 border-brandPurple text-gray-800'
                : 'text-gray-600'
            "
            class="mt-2 text-sm text-gray-600"
            >Stock Photos</span
          >
        </button>

        <button
          @click="handleChange('stock-audio', 'music-tracks')"
          class="
            w-40
            h-40
            border border-gray-800
            rounded-md
            flex flex-col
            items-center
            focus:outline-none
            justify-center
            flex-shrink-0
          "
        >
          <svg
            :class="
              mainCat === 'stock-audio' ? 'text-gray-800' : 'text-gray-600'
            "
            class="w-9 h-9"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M39 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V39C0 39.7956 0.316071 40.5587 0.87868 41.1213C1.44129 41.6839 2.20435 42 3 42H39C39.7956 42 40.5587 41.6839 41.1213 41.1213C41.6839 40.5587 42 39.7956 42 39V3C42 2.20435 41.6839 1.44129 41.1213 0.87868C40.5587 0.316071 39.7956 0 39 0ZM40 39C40 39.2652 39.8946 39.5196 39.7071 39.7071C39.5196 39.8946 39.2652 40 39 40H3C2.73478 40 2.48043 39.8946 2.29289 39.7071C2.10536 39.5196 2 39.2652 2 39V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H39C39.2652 2 39.5196 2.10536 39.7071 2.29289C39.8946 2.48043 40 2.73478 40 3V39Z"
              fill="currentColor"
            />
            <path
              d="M24 16C23.4402 15.9924 22.8848 16.1003 22.3686 16.3171C21.8524 16.5339 21.3865 16.8549 21 17.26C20.6135 16.8549 20.1476 16.5339 19.6314 16.3171C19.1152 16.1003 18.5598 15.9924 18 16C17.4717 15.9891 16.9467 16.0851 16.4564 16.2823C15.9662 16.4794 15.5209 16.7737 15.1473 17.1473C14.7737 17.5209 14.4794 17.9662 14.2823 18.4564C14.0851 18.9467 13.9891 19.4717 14 20C14 25.66 20.41 27.86 20.68 27.95C20.8845 28.0179 21.1055 28.0179 21.31 27.95C21.59 27.86 28 25.66 28 20C28.0109 19.4717 27.9149 18.9467 27.7177 18.4564C27.5205 17.9662 27.2263 17.5209 26.8527 17.1473C26.479 16.7737 26.0337 16.4794 25.5435 16.2823C25.0533 16.0851 24.5283 15.9891 24 16V16ZM21 25.93C19.85 25.46 16 23.62 16 20C15.9871 19.7339 16.03 19.4681 16.126 19.2197C16.222 18.9712 16.3688 18.7455 16.5572 18.5572C16.7455 18.3688 16.9712 18.222 17.2197 18.126C17.4681 18.03 17.7339 17.9871 18 18C18.4416 18.0102 18.8713 18.1453 19.2394 18.3895C19.6074 18.6337 19.8989 18.9771 20.08 19.38C20.1553 19.5634 20.2835 19.7203 20.4482 19.8307C20.6129 19.9411 20.8067 20 21.005 20C21.2033 20 21.3971 19.9411 21.5618 19.8307C21.7265 19.7203 21.8546 19.5634 21.93 19.38C22.1084 18.9771 22.3978 18.6334 22.7644 18.3891C23.1309 18.1447 23.5595 18.0097 24 18C24.2664 17.9855 24.5329 18.0274 24.7821 18.1228C25.0313 18.2182 25.2576 18.365 25.4463 18.5537C25.6349 18.7424 25.7818 18.9687 25.8772 19.2179C25.9726 19.4671 26.0144 19.7335 26 20C26 23.6 22.14 25.46 21 25.93Z"
              fill="currentColor"
            />
            <path
              d="M21.9999 9.00002C21.9999 8.73481 21.8946 8.48045 21.7071 8.29292C21.5195 8.10538 21.2652 8.00002 20.9999 8.00002C17.8125 7.98503 14.7305 9.14163 12.3399 11.25C12.2341 11.335 12.1466 11.4406 12.0829 11.5604C12.0192 11.6803 11.9805 11.8119 11.9693 11.9471C11.958 12.0824 11.9744 12.2185 12.0175 12.3473C12.0606 12.476 12.1294 12.5946 12.2198 12.6959C12.3102 12.7971 12.4202 12.8789 12.5433 12.9363C12.6663 12.9936 12.7997 13.0253 12.9354 13.0295C13.0711 13.0336 13.2062 13.0101 13.3324 12.9603C13.4587 12.9106 13.5736 12.8356 13.6699 12.74C15.6948 10.9591 18.3034 9.98401 20.9999 10C21.2652 10 21.5195 9.89466 21.7071 9.70713C21.8946 9.51959 21.9999 9.26524 21.9999 9.00002Z"
              fill="currentColor"
            />
            <path
              d="M37 33.18V26.68C38.4426 22.6107 38.2829 18.145 36.5532 14.1892C34.8235 10.2333 31.6535 7.08381 27.6866 5.37982C23.7196 3.67582 19.2529 3.54503 15.1931 5.01397C11.1332 6.48291 7.78435 9.44154 5.82617 13.2894C3.86798 17.1372 3.44719 21.5859 4.6492 25.7327C5.85121 29.8794 8.58596 33.4135 12.2984 35.6176C16.0108 37.8217 20.4228 38.5307 24.6389 37.6007C28.855 36.6707 32.5593 34.1714 35 30.61V33.17C34.3328 33.4059 33.7705 33.8701 33.4124 34.4805C33.0543 35.0909 32.9235 35.8083 33.0432 36.5058C33.1629 37.2032 33.5253 37.836 34.0664 38.2921C34.6074 38.7483 35.2923 38.9984 36 38.9984C36.7077 38.9984 37.3926 38.7483 37.9337 38.2921C38.4747 37.836 38.8371 37.2032 38.9568 36.5058C39.0765 35.8083 38.9457 35.0909 38.5876 34.4805C38.2296 33.8701 37.6672 33.4059 37 33.17V33.18ZM21 36C18.0333 36 15.1332 35.1203 12.6665 33.4721C10.1997 31.8238 8.27713 29.4812 7.14182 26.7403C6.0065 23.9994 5.70945 20.9834 6.28823 18.0737C6.86701 15.1639 8.29562 12.4912 10.3934 10.3934C12.4912 8.29563 15.1639 6.86702 18.0737 6.28824C20.9834 5.70946 23.9994 6.00651 26.7403 7.14183C29.4812 8.27714 31.8238 10.1997 33.4721 12.6665C35.1203 15.1332 36 18.0333 36 21C36 21.33 36 21.65 36 22C35.5343 21.379 34.9304 20.875 34.2361 20.5279C33.5418 20.1807 32.7762 20 32 20C31.7348 20 31.4804 20.1054 31.2929 20.2929C31.1054 20.4804 31 20.7348 31 21C31 21.2652 31.1054 21.5196 31.2929 21.7071C31.4804 21.8947 31.7348 22 32 22C32.7957 22 33.5587 22.3161 34.1213 22.8787C34.6839 23.4413 35 24.2044 35 25V26.34C33.9188 29.1782 32.0014 31.6213 29.5016 33.3462C27.0018 35.0711 24.0372 35.9965 21 36V36ZM36 37C35.8022 37 35.6089 36.9414 35.4444 36.8315C35.28 36.7216 35.1518 36.5654 35.0761 36.3827C35.0004 36.2 34.9806 35.9989 35.0192 35.8049C35.0578 35.6109 35.1531 35.4328 35.2929 35.2929C35.4328 35.1531 35.6109 35.0578 35.8049 35.0192C35.9989 34.9807 36.2 35.0005 36.3827 35.0761C36.5654 35.1518 36.7216 35.28 36.8315 35.4445C36.9414 35.6089 37 35.8022 37 36C37 36.2652 36.8947 36.5196 36.7071 36.7071C36.5196 36.8947 36.2652 37 36 37Z"
              fill="currentColor"
            />
            <path
              d="M5.5 7C6.32843 7 7 6.32843 7 5.5C7 4.67157 6.32843 4 5.5 4C4.67157 4 4 4.67157 4 5.5C4 6.32843 4.67157 7 5.5 7Z"
              fill="currentColor"
            />
          </svg>

          <span
            :class="
              mainCat === 'stock-audio'
                ? 'border-b-2 border-brandPurple text-gray-800'
                : 'text-gray-600'
            "
            class="mt-2 text-sm text-gray-600"
            >Stock Audio</span
          >
        </button>
      </div>

      <div
        class="
          my-5
          w-full
          flex flex-col
          md:flex-row
          md:items-start
          items-center
          justify-center
          gap-6
          max-w-3xl
          2xl:max-w-6xl
          mx-auto
        "
      >
        <button
          v-for="link in subCats[mainCat]"
          :key="link"
          :class="
            link.value === subCat
              ? 'bg-gray-900 text-white'
              : 'bg-none text-gray-900'
          "
          class="
            border border-gray-800
            rounded-md
            p-1
            w-40
            flex-shrink-0
            text-sm
            focus:outline-none
          "
          @click="subCat = link.value"
        >
          {{ link.name }}
        </button>
      </div>

      <div class="mt-10 w-full border-t border-gray-500"></div>

      <div class="w-full max-w-3xl 2xl:max-w-6xl mx-auto">
        <!-- general quality and technical -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'general' && subCat === 'quality-and-technical'"
            class=""
          >
            <p class="pt-10 text-sm text-gray-800">
              At this time, We can only accept experienced contributors. In
              order to help us better assess your experience, please be prepared
              to provide high-quality 5 items with links to previous work. There
              are specific item quality expectations that are required to sell
              the item on Vooaxis. If your item meets that standard, you can
              join our author board.
            </p>

            <p class="pt-5 text-sm text-gray-800">
              We’re splitting the net revenue between the platform and the
              authors. The profit of authors depends on the number of item
              downloads.
            </p>

            <h3 class="mt-10 text-base font-bold text-gray-900">
              Vooaxis Ridge Selection Criteria
            </h3>

            <p class="pt-5 text-sm text-gray-800">
              Now let’s look at the entry barrier for authors. If your items
              satisfy all of these demands, you will have no difficulties
              becoming an author. We sell the best-prepared items to the
              subscribers. And to create a high-quality library for subscribers,
              Thus we have created specific quality expectations. These include:
            </p>

            <ul class="mt-5 list-disc space-y-10">
              <li>
                <h3 class="text-sm font-bold text-gray-900">
                  Consistent Quality
                </h3>
                <p class="pt-2 text-sm text-gray-800">
                  Authors must have an exceptional level of quality across their
                  entire first 5 Items displaying a very high level of skill.
                  With that, we evaluate the quality of a portfolio.
                </p>
              </li>
              <li>
                <h3 class="text-sm font-bold text-gray-900">
                  Don't copy anything
                </h3>
                <p class="pt-2 text-sm text-gray-800">
                  Authors have 100% creative freedom in their work. It is good
                  to look for inspiration. But anything that appears to be a
                  copy will be rejected, and the account suspension or complete
                  ban. We have a zero-tolerance policy on this. So, please take
                  it seriously.
                </p>
              </li>
              <li>
                <h3 class="text-sm font-bold text-gray-900">
                  Up-to-date items
                </h3>
                <p class="pt-2 text-sm text-gray-800">
                  We aim to bring the best assets to our subscribers. Authors
                  need to actively create and upload new works. Items must be
                  accurately represented, with beautiful preview images and
                  collateral. Item titles, descriptions & tags must be clear and
                  compelling.
                </p>
              </li>
              <li>
                <h3 class="text-sm font-bold text-gray-900">Style</h3>
                <p class="pt-2 text-sm text-gray-800">
                  Items Must be relevant and useful to our audience. Your items
                  must have a premium quality presentation, and be useful,
                  on-trend, modern & clean.
                </p>
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of  general quality and technical -->

        <!-- general video requirements -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'general' && subCat === 'video-requirements'"
            class=""
          >
            <p class="pt-10 text-sm text-gray-800">
              It is important to organize your project file by making sure that
              you include only the files or assets needed for your project to
              work properly.
            </p>
            <p class="pt-10 text-sm text-gray-800">
              The different categories of files that you can submit to Vooaxis
              are:
            </p>
            <ul class="mt-5 list-disc list-inside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">After effects project file</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('video-templates', 'after-effects')"
                  class="text-blue-600 underline focus:outline-none"
                >
                  outlined in this article</button
                >.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">Premiere Pro Templates</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('video-templates', 'premiere-pro')"
                  class="text-blue-600 underline focus:outline-none"
                >
                  outlined in this article</button
                >.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">Presets</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('video-templates', 'presets')"
                  class="text-blue-600 underline focus:outline-none"
                >
                  outlined in this article</button
                >.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">Stock Footage File</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('stock-video', 'stock-footage')"
                  class="text-blue-600 underline focus:outline-none"
                >
                  outlined in this article</button
                >.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">Motion Graphics File</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('stock-video', 'motion-graphics')"
                  class="text-blue-600 underline focus:outline-none"
                >
                  outlined in this article</button
                >.
              </li>
            </ul>

            <h3 class="mt-10 text-base font-bold text-gray-900">
              Create a Preview Video & Using the Watermark
            </h3>

            <p class="pt-10 text-sm text-gray-800">
              Create an H.264 MP4 version of your video at 960x540 and overlay
              the
              <a
                href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_video_watermark.zip?alt=media&token=089a8964-52b6-4379-a581-7db1b751595b"
                download=""
                class="text-blue-600 underline"
                >video watermark</a
              >
              when applicable. This will help prevent copyright breach and
              unauthorized use of your file.
            </p>

            <p class="pt-5 text-sm text-gray-800">
              Ensuring subscribers buy your item by making video high quality.
              This will clarify what is in your item. Use the Motionridge
              watermark where your preview contains the actual item. For Project
              Files or other categories requiring customization, the watermark
              is not required since customers need access to the source files in
              order to use the video.
            </p>

            <p class="pt-5 text-sm text-gray-800">
              The following categories <span class="font-bold">DO</span> require
              watermark in the require a watermark in the preview videos:
            </p>
            <ul class="mt-5 list-disc list-inside space-y-2">
              <li class="text-sm text-gray-800">Stock Footage</li>
              <li class="text-sm text-gray-800">Motion Graphics</li>
            </ul>

            <p class="pt-5 text-sm text-gray-800">
              The following categories
              <span class="font-bold">DO NOT</span> require watermark in the
              require a watermark in the preview videos:
            </p>
            <ul class="mt-5 list-disc list-inside space-y-2">
              <li class="text-sm text-gray-800">After effects project files</li>
              <li class="text-sm text-gray-800">After effects presets</li>
              <li class="text-sm text-gray-800">Premiere pro templates</li>
              <li class="text-sm text-gray-800">Premiere pro presets</li>
            </ul>

            <div class="mt-5 px-2 py-2 rounded-md bg-yellow-100">
              <h4 class="text-sm text-yellow-800">
                Except for the official Motionridge watermark, we do not accept
                submission with additional watermark or branding.
              </h4>
            </div>

            <h3 class="mt-10 text-base font-bold text-gray-900">
              Create a Help File
            </h3>

            <p class="pt-5 text-sm text-gray-800">
              Every project file in MotionRidge should have a built-in help
              file. This help file will be a quick guide for clients through
              your organizational methods, naming conventions, combinations,
              layers and effect parameters. The help file should be a short and
              effective guide to your file within the software.
            </p>

            <h3 class="mt-10 text-base font-medium text-gray-900">
              Which Format Should I Choose?
            </h3>
            <p class="pt-5 text-sm text-gray-800">
              At this point, you need to choose which format of your help file.
              And it's really up to you. Cross OS compatible (Windows & Mac) We
              accept the following formats and it can effectively explain the
              process:
            </p>

            <ul class="mt-5 list-disc list-inside space-y-2">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Video tutorials</span>
                - Many authors make screen recordings very easy. Especially in
                terms of time. Videos are also preferred by many customers.
                Video tutorials should be provided in MOV or MP4 formats.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">PDF</span>
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">HTML</span>
              </li>
            </ul>

            <p class="pt-5 text-sm text-gray-800">
              Choose the format, including the required information, and then
              add it to the zip folder of your main file. Your project file
              along with the help file will be reviewed by our team and they
              will contact you if anything needs to be changed or added.
            </p>

            <h3 class="mt-10 text-base font-medium text-gray-900">
              Adding Audio references to Video Items
            </h3>

            <p class="pt-5 text-sm text-gray-800">
              If you have used a watermarked motionridge track in your video
              preview to showcase your item, you need to add a credit (otherwise
              known as an attribute) to your item description. Please note,
              these are previews only and you may not include other authors'
              watermarked items in your item download.
            </p>
          </div>
        </Transition>
        <!-- end of general video requirements -->

        <!-- general audio requirements -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'general' && subCat === 'audio-requirements'"
            class=""
          >
            <p class="pt-10 text-sm text-gray-800">
              It is important to organize your project file by making sure that
              you include only the files or assets needed for your project to
              work properly.
            </p>
            <p class="pt-10 text-sm text-gray-800">
              The different categories of files that you can submit to Vooaxis
              are:
            </p>
            <ul class="mt-5 list-disc list-inside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Royalty free music</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('stock-audio', 'music-tracks')"
                  class="focus:outline-none text-blue-600 underline"
                >
                  outlined in this article</button
                >.
              </li>
              <li class="text-sm text-gray-800">
                <span class="font-bold">Sound effects</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('stock-audio', 'sound-effects')"
                  class="focus:outline-none text-blue-600 underline"
                >
                  outlined in this article</button
                >.
              </li>
            </ul>

            <h3 class="mt-10 text-base font-bold text-gray-900">
              Create a Preview Audio & Using the Watermark
            </h3>

            <p class="pt-10 text-sm text-gray-800">
              Create an MP3 version of your audio and overlay the
              <a
                href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_audio_watermark.zip?alt=media&token=98ce1729-e892-4996-9cf1-62af346107cf"
                download
                class="text-blue-600 underline"
                >audio watermark</a
              >
              when applicable. This will help prevent copyright breaches and
              unauthorized use of your file.
            </p>

            <div class="mt-5 px-2 py-2 rounded-md bg-yellow-100">
              <h4 class="text-sm text-yellow-800">
                Except for the official Motionridge watermark, we do not accept
                submission with additional watermark or branding.
              </h4>
            </div>

            <h3 class="mt-10 text-base font-bold text-gray-900">About P.R.O</h3>

            <p class="pt-5 text-sm text-gray-800">
              To ensure a consistent experience and music delivery for
              customers, all MotionRidge authors have some additional settings
              and requirements as part of this new policy, and obligations for
              authors who wish to sell PRO music.
            </p>

            <p class="pt-5 text-sm text-gray-800">
              P.R.O. The system and attribute information we collect will be
              used to provide additional clarity and transparency for
              AudioJungle customers during their search, browsing and purchasing
              experience.
            </p>

            <h3 class="mt-10 text-base font-bold text-gray-900">
              Your Music With YouTube Content ID
            </h3>
            <p class="pt-5 text-sm text-gray-800">
              As a marketplace, we recognize and respect the right of individual
              authors to protect us from copyright infringement and the
              unauthorized use of their content. This includes the use of
              digital fingerprint systems, such as YouTube's Content ID, and
              YouTube Partner sites such as Adrev, Adium or Tune Core to help
              manage and manage the copyrighted content associated with it.
            </p>

            <p class="pt-5 text-sm text-gray-800">
              Teachers with digital fingerprint music have some additional
              requirements and obligations to help buyers ensure a consistent
              experience and to have no problems with videos that use licensed
              music.
            </p>
          </div>
        </Transition>
        <!-- end of general audio requirements -->

        <!-- general photo requirements -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'general' && subCat === 'photo-requirements'"
            class=""
          >
            <div class="mt-5 px-2 py-2 rounded-md bg-red-100">
              <h4 class="text-sm text-red-800">
                <span class="font-bold">
                  Photo submissions are temporarily closed.</span
                >
                We’ll be back soon with a smoother process and faster review
                times.
              </h4>
            </div>
            <p class="pt-10 text-sm text-gray-800">
              It is important to organize your project file by making sure that
              you include only the files or assets needed for your project to
              work properly.
            </p>
            <p class="pt-10 text-sm text-gray-800">
              The different categories of files that you can submit to Vooaxis
              are:
            </p>
            <ul class="mt-5 list-disc list-inside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Stock Photos</span>
                - Ensure that your project file meets the requirements
                <button
                  @click="handleChange('stock-photos', '')"
                  class="focus:outline-none text-blue-600 underline"
                >
                  outlined in this article</button
                >.
              </li>
            </ul>

            <ul class="mt-10 list-disc list-outside space-y-12">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Mature content:</span>
                <p class="mt-2 text-sm text-gray-800">
                  Photos may not contain sexual content or full nudity.
                </p>
                <p class="text-sm text-gray-800">
                  Photos may not promote violence, sexism, racism, bigotry, etc.
                </p>
                <p class="text-sm text-gray-800">
                  Photos may not contain profanity or explicit language.
                </p>
                <p class="text-sm text-gray-800">
                  You must only submit photos that are suitable for a broader
                  audience.
                </p>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Similar/Duplicate shots:</span>
                <p class="mt-2 text-sm text-gray-800">
                  When submitting similar photos or photos from the same
                  photoshoot, only upload unique and high-quality shots.
                </p>
                <p class="text-sm text-gray-800">
                  Do not submit overly similar shots, repeats, or duplicate
                  photos with too many identical scenes, even with minor
                  differences or changes
                </p>
                <p class="text-sm text-gray-800">
                  Submitting overly similar images will be flagged as spamming
                  and may impact your account status.
                </p>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Intellectual Property:</span>
                <p class="mt-2 text-sm text-gray-800">
                  Please do not submit trademarks, brands, logos, copyrighted
                  products/artwork or anything you do not own or have the right
                  to sell.
                </p>
                <p class="text-sm text-gray-800">
                  That means no editorial content (photos for non-commercial,
                  non-promotional use only, without appropriate model/property
                  releases). If you submit photos depicting identifiable people
                  (even if the face is not visible) or identifiable buildings,
                  you will need to include a signed release form.
                </p>
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of general photo requirements -->

        <!-- Video templates after effects -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'video-templates' && subCat === 'after-effects'"
            class=""
          >
            <ul class="mt-16 list-disc list-outside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Versions:</span>
                After Effects templates should be saved in the original created
                version.
              </li>
            </ul>

            <p class="mt-2 text-sm text-gray-800">
              Some project elements, such as expressions, may break after
              projects are built into newer versions, but will be saved for
              older versions.
            </p>

            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Project structure:</span>
                All items must follow a clean and organized folder structure in
                the After Effects Template example package.
                <div class="mt-2 flex items-center justify-center">
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotion%20Ridge%20After%20Effects%20Template%20Example%20Package.zip?alt=media&token=9a35d9f0-3ca4-4c65-b50d-a10340cf2848"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Adobe After Effects Template example package.
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Logos:</span>
                If your template uses logos, you must use generic logos. A set
                of generic logos are included in the master brand logo pack. You
                are welcome to use these logos.
                <div class="mt-2 flex items-center justify-center">
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FVooaxis-MasterBrand-Logopack.zip?alt=media&token=33d818cd-a78f-46f0-aa38-bc24dfaf953c"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Vooaxis logo as a placeholder for Logo Stings or Reveals
                  </a>
                </div>
              </li>

              <ul class="mt-5 list-disc list-outside space-y-10">
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Audio:</span>
                  You must use music from Motion Ridge in your template’s
                  <a
                    class="text-blue-500 underline"
                    href="https://motionridge.com/royalty-free-music"
                    target="_blank"
                    >preview</a
                  >.
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Placeholders:</span>
                  You may use images or videos from sites that are subject to
                  the Royalty-free license.
                  <span class="mt-2 block">
                    Any assets used in your preview that cannot be added to your
                    zip file should be replaced with placeholder assets to
                    prevent missing file errors. Customers can easily replace
                    reserved assets with their own assets when editing the plan.
                    You can use the following in the preview of your file and
                    add it as a placeholder in your zip folder:
                  </span>

                  <div class="mt-5 px-2 py-2 rounded-md bg-yellow-100">
                    <h4 class="text-sm text-yellow-800">
                      After creating your preview assets, the render queue must
                      be cleared before the final storage of your project file.
                    </h4>
                  </div>
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Fonts:</span>
                  Adobe Fonts are preferred, as these will auto-sync for users
                  when they open the project. Any non-Adobe fonts used need to
                  be available for free. No paid fonts (aside from Adobe Fonts)
                  are allowed in your projects.

                  <span class="block mt-5 underline"
                    >Actual font files should not be included in the final
                    upload.
                  </span>
                  <span class="block mt-5 underline"
                    >Links to the fonts are required when using non-Adobe Fonts.
                  </span>
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">Tutorial:</span>
                  Many authors make screen recordings very easy. Especially in
                  terms of time. Videos are also preferred by many customers.
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">.Zip format:</span>
                  The download package must be compressed and in .zip format.
                  All project folders should have the same name as the main file
                  and title of an item.
                </li>
              </ul>
            </ul>
          </div>
        </Transition>
        <!-- end of Video templates after effects -->

        <!-- Video templates premiere pro -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'video-templates' && subCat === 'premiere-pro'"
            class=""
          >
            <ul class="mt-16 list-disc list-outside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Versions:</span>
                Premiere pro should be saved in the original created version.
              </li>
            </ul>

            <p class="mt-2 text-sm text-gray-800">
              Some project elements, such as expressions, may break after
              projects are built into newer versions, but will be saved for
              older versions.
            </p>

            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Project structure:</span>
                All items must follow a clean and organized folder structure in
                the Premiere pro example package.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotion%20Ridge%20Premiere%20Pro%20Sample%20Project.zip?alt=media&token=ab0c8b3f-eefd-417c-ac3b-89cf462afff0"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Adobe Premiere pro example package.
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotion%20Ridge%20Premiere%20Pro%20MOGRT%20Example%20Package.zip?alt=media&token=687592f8-d193-4785-885d-e9666a1ab8c3"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    MOGRT example package.
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Logos:</span>
                If your template uses logos, you must use generic logos. A set
                of generic logos are included in the master brand logo pack. You
                are welcome to use these logos.
                <div class="mt-2 flex items-center justify-center">
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FVooaxis-MasterBrand-Logopack.zip?alt=media&token=33d818cd-a78f-46f0-aa38-bc24dfaf953c"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Vooaxis logo as a placeholder for Logo Stings or Reveals
                  </a>
                </div>
              </li>

              <ul class="mt-5 list-disc list-outside space-y-10">
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Audio:</span>
                  You must use music from Motion Ridge in your template’s
                  <a
                    class="text-blue-500 underline"
                    href="https://motionridge.com/royalty-free-music"
                    target="_blank"
                    >preview</a
                  >.
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Placeholders:</span>
                  You may use images or videos from sites that are subject to
                  the Royalty-free license.
                  <span class="mt-2 block">
                    Any assets used in your preview that cannot be added to your
                    zip file should be replaced with placeholder assets to
                    prevent missing file errors. Customers can easily replace
                    reserved assets with their own assets when editing the plan.
                    You can use the following in the preview of your file and
                    add it as a placeholder in your zip folder:
                  </span>

                  <div class="mt-5 px-2 py-2 rounded-md bg-yellow-100">
                    <h4 class="text-sm text-yellow-800">
                      After creating your preview assets, the render queue must
                      be cleared before the final storage of your project file.
                    </h4>
                  </div>
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Fonts:</span>
                  Adobe Fonts are preferred, as these will auto-sync for users
                  when they open the project. Any non-Adobe fonts used need to
                  be available for free. No paid fonts (aside from Adobe Fonts)
                  are allowed in your projects.

                  <span class="block mt-5 underline"
                    >Actual font files should not be included in the final
                    upload.
                  </span>
                  <span class="block mt-5 underline"
                    >Links to the fonts are required when using non-Adobe Fonts.
                  </span>
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">Template file types:</span>
                  Premiere Pro compatible templates can be created two ways:
                  <span class="block mt-5">
                    <span class="font-bold">Adobe Premiere Pro</span>
                    -Actual font files should not be included in the final
                    upload.
                  </span>
                  <span class="block mt-5">
                    <span class="font-bold">Adobe After Effects</span>
                    -Templates created in Adobe After Effects need to be
                    exported as Motion Graphics Template files, and will contain
                    the
                    <span class="font-medium">.mogrt</span> file extension.
                  </span>

                  <span class="block mt-5">
                    Project files may include one or both of the above formats
                    (.prproj / .mogrt) to provide optimal flexibility. When used
                    in Premiere Pro, both file formats use the Essential
                    Graphics panel to control the customizable features of a
                    template.
                  </span>
                </li>

                <li>
                  <span class="font-bold">Note:</span>
                  <ul class="mt-2 list-inside list-decimal space-y-5">
                    <li class="text-sm text-gray-800">
                      If your .mogrt files have been created or exported from
                      After Effects, you must select After Effects CC in the
                      Software Version attribute during upload so that customers
                      know when to install Effects on their system.
                    </li>
                    <li class="text-sm text-gray-800">
                      In addition, you should mention the need for After Effects
                      in the item description and supporting documents.
                    </li>
                  </ul>
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">Tutorial:</span>
                  Many authors make screen recordings very easy. Especially in
                  terms of time. Videos are also preferred by many customers.
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">.Zip format:</span>
                  The download package must be compressed and in .zip format.
                  All project folders should have the same name as the main file
                  and title of an item.
                </li>
              </ul>
            </ul>
          </div>
        </Transition>
        <!-- end of Video templates premiere pro -->

        <!-- Video templates presets -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'video-templates' && subCat === 'presets'"
            class=""
          >
            <ul class="mt-16 list-disc list-outside space-y-5">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Template file types:</span>
                Compatible templates can be created two ways:
                <span class="block mt-5">
                  <span class="font-bold">Premiere Pro Presets</span>
                  -Actual font files should not be included in the final upload.
                </span>
                <span class="block mt-5">
                  <span class="font-bold">After Effects Presets</span>
                  -Templates created in Adobe After Effects need to be exported
                  as Motion Graphics Template files, and will contain the
                  <span class="font-medium">.mogrt</span> file extension.
                </span>

                <span class="block mt-5">
                  Project files may include one or both of the above formats
                  (Presets) to provide optimal flexibility.
                </span>
              </li>
            </ul>

            <p class="mt-2 text-sm text-gray-800">
              Some project elements, such as expressions, may break after
              projects are built into newer versions, but will be saved for
              older versions.
            </p>

            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Project structure:</span>
                All items must follow a clean and organized folder structure in
                the After Effects Template example package.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotion%20Ridge%20After%20Effects%20Preset%20Example%20Package.zip?alt=media&token=1cbf53cf-92ad-4f5f-9787-e334234fcfb4"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Adobe After Effects Presets example package.
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotion%20Ridge%20Premiere%20Pro%20Preset%20Example%20Package.zip?alt=media&token=c29dafb0-125c-481b-ba2e-d8abb39b47af"
                    download
                    class="
                      block
                      py-1
                      px-6
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      flex-shrink-0
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Adobe Premiere Pro presets example package.
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Logos:</span>
                If your template uses logos, you must use generic logos. A set
                of generic logos are included in the master brand logo pack. You
                are welcome to use these logos.
                <div class="mt-2 flex items-center justify-center">
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FVooaxis-MasterBrand-Logopack.zip?alt=media&token=33d818cd-a78f-46f0-aa38-bc24dfaf953c"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Vooaxis logo as a placeholder for Logo Stings or Reveals
                  </a>
                </div>
              </li>

              <ul class="mt-5 list-disc list-outside space-y-10">
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Audio:</span>
                  You must use music from Motion Ridge in your template’s
                  <a
                    class="text-blue-500 underline"
                    href="https://motionridge.com/royalty-free-music"
                    target="_blank"
                    >preview</a
                  >.
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Placeholders:</span>
                  You may use images or videos from sites that are subject to
                  the Royalty-free license.
                  <span class="mt-2 block">
                    Any assets used in your preview that cannot be added to your
                    zip file should be replaced with placeholder assets to
                    prevent missing file errors. Customers can easily replace
                    reserved assets with their own assets when editing the plan.
                    You can use the following in the preview of your file and
                    add it as a placeholder in your zip folder:
                  </span>

                  <div class="mt-5 px-2 py-2 rounded-md bg-yellow-100">
                    <h4 class="text-sm text-yellow-800">
                      After creating your preview assets, the render queue must
                      be cleared before the final storage of your project file.
                    </h4>
                  </div>
                </li>
                <li class="text-sm text-gray-800">
                  <span class="font-bold">Fonts:</span>
                  Adobe Fonts are preferred, as these will auto-sync for users
                  when they open the project. Any non-Adobe fonts used need to
                  be available for free. No paid fonts (aside from Adobe Fonts)
                  are allowed in your projects.

                  <span class="block mt-5 underline"
                    >Actual font files should not be included in the final
                    upload.
                  </span>
                  <span class="block mt-5 underline"
                    >Links to the fonts are required when using non-Adobe Fonts.
                  </span>
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">Tutorial:</span>
                  Many authors make screen recordings very easy. Especially in
                  terms of time. Videos are also preferred by many customers.
                </li>

                <li class="text-sm text-gray-800">
                  <span class="font-bold">.Zip format:</span>
                  The download package must be compressed and in .zip format.
                  All project folders should have the same name as the main file
                  and title of an item.
                </li>
              </ul>
            </ul>
          </div>
        </Transition>
        <!-- end of Video templates presets -->

        <!-- stock video stock footage  -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'stock-video' && subCat === 'stock-footage'"
            class=""
          >
            <div class="mt-16 px-2 py-2 rounded-md bg-yellow-100">
              <h4 class="text-sm text-yellow-800">
                Stock Footage must be a minimum of 5 seconds of usable footage
                in order to be accepted. If 5 usable seconds cannot be produced
                in any one clip, we suggest packing together a few similar clips
                that when combined will equal 5 seconds or more in total length.
              </h4>
            </div>

            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">File format:</span>
                Stock Footage must be provided in one of the following formats:
                <span class="block font-bold mt-5 ml-5"> Quicktime mov </span>
                <span class="block font-bold mt-2 ml-5"> MP4 </span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Encoding format:</span>
                Following are the accepted encoding formats:
                <span class="block mt-5 ml-5"> Photo JPEG </span>
                <span class="block mt-2 ml-5"> Photo PNG + Alpha </span>
                <span class="block mt-2 ml-5">Apple ProRes 422</span>
                <span class="block mt-2 ml-5">Apple ProRes 422 HQ</span>
                <span class="block mt-2 ml-5">Apple ProRes 4444</span>
                <span class="block mt-2 ml-5">H.264</span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Resolution</span>
                Stock Footage should be submitted in one of the following
                resolutions:
                <span class="block mt-5 ml-5">1920 X 1080</span>

                <span class="block mt-2 ml-5">
                  2K (2048x1080 minimum resolution)</span
                >
                <span class="block mt-2 ml-5"
                  >4K (3840x2160 minimum resolution)</span
                >
                <span class="block mt-2 ml-5"
                  >8K (7680x4320 minimum resolution)</span
                >
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Editorial use:</span>
                If your project includes footage of a popular visible brand or
                product logos, specifically recognisable locations need to be
                classified as “Editorial Use”. Failing to properly classify
                usage on your footage can result in account suspension or a
                complete ban.
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Model Releases:</span>
                If your project has been approved by private property, such as a
                human face or identifiable feature, you will need to submit a
                signed talent or property release, which you must scan the
                release forms and upload in PDF or JPG format.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FMinor%20release.pdf?alt=media&token=12d37282-9c3e-4b46-ba1e-848ac500dcbe"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Minor release
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FModel%20release.pdf?alt=media&token=08fc3bb0-9741-44a0-8df7-6baa59678338"
                    download
                    class="
                      block
                      py-1
                      px-6
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      flex-shrink-0
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Model release
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FProperty%20release.pdf?alt=media&token=9a308388-0430-486b-9248-68f5400e709d"
                    download
                    class="
                      block
                      py-1
                      px-6
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      flex-shrink-0
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Property release
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Video preview:</span>
                Preview video must include the video watermark. Specifies the
                resolution of your preview video in pixels, width by height
                (960x540), Maximum file size should be 100MB., The accepted
                video format is MP4.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_video_watermark.zip?alt=media&token=089a8964-52b6-4379-a581-7db1b751595b"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Video Watermark
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Image preview</span>
                Subscribers look at your cover image and identify the item they
                are looking for, so you need to make it attractive. This is your
                chance to showcase your item! Specifies the resolution of your
                preview video in pixels, width by height (960x540), Maximum file
                size should be 2MB., The Accepted image formats are JPEG, or
                JPG.
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">File Size</span>
                Specifies the final file size of your item (final zip file). The
                maximum file size of your .ZIP file must not exceed 2GB.
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of stock video stock footage -->

        <!-- stock video motion graphics  -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'stock-video' && subCat === 'motion-graphics'"
            class=""
          >
            <div class="mt-16 px-2 py-2 rounded-md bg-yellow-100">
              <h4 class="text-sm text-yellow-800">
                Motion Graphics submissions have no minimum duration
                requirements. However, if your file is less than 2 seconds, we
                recommend you create it as a seamless loop or pack together with
                few similar animations to create an optimal overall package.
              </h4>
            </div>

            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">File format:</span>
                Motion Graphics must be provided in one of the following
                formats:
                <span class="block font-bold mt-5 ml-5"> Quicktime mov </span>
                <span class="block font-bold mt-2 ml-5"> MP4 </span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Encoding format:</span>
                Following are the accepted encoding formats:
                <span class="block mt-5 ml-5"> Photo JPEG </span>
                <span class="block mt-2 ml-5"> Photo PNG + Alpha </span>
                <span class="block mt-2 ml-5">Apple ProRes 422</span>
                <span class="block mt-2 ml-5">Apple ProRes 422 HQ</span>
                <span class="block mt-2 ml-5">Apple ProRes 4444</span>
                <span class="block mt-2 ml-5">H.264</span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Resolution</span>
                Motion Graphics should be submitted in one of the following
                resolutions:
                <span class="block mt-5 ml-5">1920 X 1080</span>

                <span class="block mt-2 ml-5">
                  2K (2048x1080 minimum resolution)</span
                >
                <span class="block mt-2 ml-5"
                  >4K (3840x2160 minimum resolution)</span
                >
                <span class="block mt-2 ml-5"
                  >8K (7680x4320 minimum resolution)</span
                >
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Video preview:</span>
                Preview video must include the video watermark. Specifies the
                resolution of your preview video in pixels, width by height
                (960x540), Maximum file size should be 100MB., The accepted
                video format is MP4.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_video_watermark.zip?alt=media&token=089a8964-52b6-4379-a581-7db1b751595b"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Video Watermark
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Image preview</span>
                Subscribers look at your cover image and identify the item they
                are looking for, so you need to make it attractive. This is your
                chance to showcase your item! Specifies the resolution of your
                preview video in pixels, width by height (960x540), Maximum file
                size should be 2MB., The Accepted image formats are JPEG, or
                JPG.
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">File Size</span>
                Specifies the final file size of your item (final zip file). The
                maximum file size of your .ZIP file must not exceed 2GB.
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of stock video motion graphics -->

        <!-- stock photos  -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div v-if="mainCat === 'stock-photos' && subCat === ''" class="">
            <div class="mt-16 px-2 py-2 rounded-md bg-red-100">
              <h4 class="text-sm text-red-800">
                <span class="font-bold">
                  Photo submissions are temporarily closed.</span
                >
                We’ll be back soon with a smoother process and faster review
                times.
              </h4>
            </div>
            <ul class="mt-10 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">Accepted Photo Types:</span>
                Please save and submit your photos as JPEGs at their highest
                available resolution/quality. Photos should not be zipped when
                uploaded.

                <span class="block mt-5">
                  Extremely high quality, photo-realistic 3D renders may be
                  acceptable as images.
                </span>
                <span class="block mt-5">
                  Do not submit any illustrations or vectors, even as fully
                  rasterized images.
                </span>
                <span class="block mt-5"
                  >Photographs containing a physical description, drawing or
                  general artwork as part of the photograph will be accepted
                  until appropriate property publications are provided.
                </span>
                <span class="block mt-5"
                  >Please limit color correction and photo processing, as overly
                  processed or color correct photos may not be accepted.
                </span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Specifications:</span>
                <span class="block mt-5"> Photos must be RGB formatted</span>
                <span class="block mt-5">
                  JPG files only. Our upload system will ignore all other file
                  types.
                </span>
                <span class="block mt-5"
                  >JPG files only. Our upload system will ignore all other file
                  types.2</span
                >
                <span class="block mt-5"
                  >Please be sure to check your images at 100% full-resolution
                  before submitting to inspect for any issues and ensure it
                  meets our technical quality requirements.</span
                >
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Resolution</span>
                Photos must be between 4 megapixels (4.0 MP) and 80 megapixels
                (80.0 MP) in size.

                <span class="block mt-5"
                  >Downsizing may be acceptable in certain situations to help
                  reduce problems such as distraction and noise, however, we
                  prefer high-quality, high-resolution photos that are best
                  executed from start to finish, keeping in mind our minimum
                  resolution requirements.</span
                >
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Editorial use:</span>
                If your project includes photos of a popular visible brand or
                product logos, specifically recognisable locations need to be
                classified as “Editorial Use”. Failing to properly classify
                usage on your photos can result in account suspension or a
                complete ban.
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Model Releases:</span>
                If your project has been approved by private property, such as a
                human face or identifiable feature, you will need to submit a
                signed talent or property release, which you must scan the
                release forms and upload in PDF or JPG format.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FMinor%20release.pdf?alt=media&token=12d37282-9c3e-4b46-ba1e-848ac500dcbe"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Minor release
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FModel%20release.pdf?alt=media&token=08fc3bb0-9741-44a0-8df7-6baa59678338"
                    download
                    class="
                      block
                      py-1
                      px-6
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      flex-shrink-0
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Model release
                  </a>
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmarketplace_releases%2FProperty%20release.pdf?alt=media&token=9a308388-0430-486b-9248-68f5400e709d"
                    download
                    class="
                      block
                      py-1
                      px-6
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      flex-shrink-0
                      hover:bg-gray-800
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Property release
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of stock photos -->

        <!-- stock audio music-tracks   -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'stock-audio' && subCat === 'music-tracks'"
            class=""
          >
            <ul class="mt-16 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">File formats:</span>
                All submissions should be in a .zip folder (both single and
                multi-file downloads).

                <span class="block mt-5">
                  All files must be 44.1 kHz 16-Bit stereo.
                </span>
                <span class="block mt-5">
                  Your file can be in WAV format and/or MP3 format.
                </span>
                <span class="block mt-5">
                  MP3 files must have a constant bit rate (CBR) of 320 kbps.
                </span>
                <span class="block mt-5"
                  >Please limit color correction and photo processing, as overly
                  processed or color correct photos may not be accepted.
                </span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Previews</span>
                Preview audio must include the audio watermark. Submissions of
                two seconds or more must be accompanied by an Motionridge
                watermark to the author's preview. Accepted audio format is MP3,
                Maximum file size should be 30MB. Do not edit the watermark in
                any way.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_audio_watermark.zip?alt=media&token=98ce1729-e892-4996-9cf1-62af346107cf"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Audio Watermark
                  </a>
                </div>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">For a music upload:</span>

                <span class="block mt-5">
                  You can add up to 5 variations to a piece of music (including
                  the main track).
                </span>
                <span class="block mt-5">
                  You can choose to upload the main track, the short loop
                  version, the instrumental version and the logo version.
                </span>
                <span class="block mt-5"
                  >The maximum length of a music track is 10 minutes.
                </span>
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of stock audio music-tracks -->

        <!-- stock audio music-tracks   -->
        <Transition
          enter-active-class="transition duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="mainCat === 'stock-audio' && subCat === 'sound-effects'"
            class=""
          >
            <ul class="mt-16 list-disc list-outside space-y-10">
              <li class="text-sm text-gray-800">
                <span class="font-bold">File formats:</span>
                All submissions should be in a .zip folder (both single and
                multi-file downloads).

                <span class="block mt-5">
                  All files must be 44.1 kHz 16-Bit stereo.
                </span>
                <span class="block mt-5">
                  Your file can be in WAV format and/or MP3 format.
                </span>
                <span class="block mt-5">
                  MP3 files must have a bit rate of 320 kbps.
                </span>
                <span class="block mt-5">
                  If you have saved a sequence of files, make sure they are
                  named correctly.
                </span>
                <span class="block mt-5">
                  The maximum number of sounds you can add to a pack is 50
                  samples.
                </span>
                <span class="block mt-5">
                  The maximum duration must not exceed 10 minutes.
                </span>
              </li>

              <li class="text-sm text-gray-800">
                <span class="font-bold">Previews</span>
                Preview audio must include the audio watermark. Submissions of
                two seconds or more must be accompanied by an Motionridge
                watermark to the author's preview. Accepted audio format is MP3,
                Maximum file size should be 30MB. Do not edit the watermark in
                any way.
                <div
                  class="
                    mt-2
                    flex flex-col
                    md:flex-row
                    gap-5
                    items-center
                    justify-center
                  "
                >
                  <a
                    href="https://firebasestorage.googleapis.com/v0/b/motion-ridge-b81bb.appspot.com/o/evaxo-assets-folder-structure%2Fmotion-ridge-folder-structure%2FMotionRidge_audio_watermark.zip?alt=media&token=98ce1729-e892-4996-9cf1-62af346107cf"
                    download
                    class="
                      block
                      py-1
                      px-10
                      rounded-md
                      border border-gray-800
                      text-sm
                      font-medium
                      text-center
                      hover:bg-gray-800
                      flex-shrink-0
                      hover:text-white
                      focus:outline-none
                    "
                  >
                    Audio Watermark
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </Transition>
        <!-- end of stock audio music-tracks -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Upload rules",
  component: {},
  methods: {
    handleChange(cat, subCat) {
      this.mainCat = cat;
      this.subCat = subCat;
      console.log({ cat, subCat });
    },
  },
  data() {
    return {
      mainCat: "general",
      subCat: "quality-and-technical",

      subCats: {
        general: [
          {
            name: "Quality and technical",
            value: "quality-and-technical",
          },
          {
            name: "Video requirements",
            value: "video-requirements",
          },
          {
            name: "Audio requirements",
            value: "audio-requirements",
          },
          {
            name: "Photo requirements",
            value: "photo-requirements",
          },
        ],

        "video-templates": [
          {
            name: "After Effects",
            value: "after-effects",
          },
          {
            name: "Premiere pro",
            value: "premiere-pro",
          },
          {
            name: "Presets",
            value: "presets",
          },
        ],

        "stock-video": [
          {
            name: "Stock Footage",
            value: "stock-footage",
          },
          {
            name: "Motion Graphics",
            value: "motion-graphics",
          },
        ],

        "stock-audio": [
          {
            name: "Music tracks",
            value: "music-tracks",
          },
          {
            name: "Sound Effects",
            value: "sound-effects",
          },
        ],
      },
    };
  },
};
</script>
